import { ref, computed } from 'vue'
import { BooleanObject } from '@/types/public'
import wxHost from '@/utils/wx'
import AppHost, { isApp, NFProgrameVersions } from '@/utils/app'
import { UserAuthorizationStorage } from '@/storage/common'
import {
  USER_NEARBY_WAREHOUSE_AUTH,
  USER_OPEN_WX_MINIPROGRAME_AUTH,
  USER_AFTERSALE_REPAIR_CAMERA_AUTH,
  USER_JIJIA_INSURANCE_BUY_LOCATION_AUTH,
  USER_AFTERSALE_REPAIR_NEARBY_WAREHOUSE_AUTH,
} from '@/config/constant'
import { showConfirmModal } from '@/utils/tools'
export const AuthorizationTypeMessageMap = new Map([
  [
    USER_AFTERSALE_REPAIR_CAMERA_AUTH,
    '为了帮您完成售后故障报修，仅在本次报修过程中临时调用摄像头拍摄故障情况，方便维修人员排查。请点击‘允许’授权。',
  ],
  [
    USER_AFTERSALE_REPAIR_NEARBY_WAREHOUSE_AUTH,
    '为了帮您完成售后故障报修，仅在本次报修过程中临时获取地理位置，方便就近选择维修网点。请点击‘允许’授权。',
  ],
  [
    USER_NEARBY_WAREHOUSE_AUTH,
    '为了帮您匹配附近网点信息，仅在本次使用过程中临时获取地理位置，方便获取网点信息。请点击‘允许’授权。',
  ],
  [
    USER_JIJIA_INSURANCE_BUY_LOCATION_AUTH,
    '为了帮您完成意外机损险购买，仅在本次报修过程中临时获取地理位置，平安保险将根据经纬度获取到对应购买保险的具体位置信息。请点击‘允许’授权。',
  ],
  [USER_OPEN_WX_MINIPROGRAME_AUTH, '即将离开当前应用，进入微信小程序'],
])
export const needAuth = isApp
export function useUserPermissionVerify(defaultKey?: string) {
  const hasAuthorized = ref(false) // 默认app都不需要处理
  async function checkAuthorizationHandle(
    key: string = defaultKey,
    options?: {
      saveSelected?: boolean // 是否保存用户选择，默认true
      cofirmModalClassName?: string // 确认弹窗的补充类名
    }
  ) {
    if (!needAuth) {
      // 默认权限弹窗都由app本身实现
      return true
    }
    const message = AuthorizationTypeMessageMap.get(key)
    const saveSelected = options?.saveSelected ?? true
    if (!message) {
      // 未配置提示语时，为不影响体验，直接就可继续
      return true
    }
    const authInfo = UserAuthorizationStorage.get<BooleanObject>()
    if (authInfo?.[key]) {
      return true
    }
    try {
      await showConfirmModal({
        title: '提示',
        message,
        confirmButtonText: '允许',
        cancelButtonText: '不允许',
        className: 'nongfu-dialog-confirm-class' + ' ' + (options?.cofirmModalClassName ?? ''),
      })
      // 允许了则默认情况下进行记录，后续不用在使用
      if (saveSelected) {
        UserAuthorizationStorage.set({
          ...authInfo,
          [key]: true,
        })
      }

      // 重置是否授权的判断
      initUserAuthInfo()
      return true
    } catch (error) {
      console.log('error', error)
    }
    return false
  }
  // 打开小程序时的通用授权
  async function beforeAuthOpenWxMiniProgramHandle(params: {
    id: string
    path: string
    version: NFProgrameVersions
  }): Promise<boolean> {
    // 小程序内不需要授权，默认为同意打开
    // const isAuth = wxHost?.isMiniprogram
    //   ? true
    //   : await checkAuthorizationHandle(USER_OPEN_WX_MINIPROGRAME_AUTH, {
    //       saveSelected: false,
    //       cofirmModalClassName: 'nongfu-dialog-message-center',
    //     })
    // 后续由APP原生自行实现，不需要前端进行告知用户
    const isAuth = true
    if (isAuth) {
      // 已经授权，直接打开
      AppHost.openMiniProgram(params.id, params.path, params.version)
    } else {
      // 未授权则不打开，静默处理
      return false
    }
    return true
  }

  function initUserAuthInfo() {
    if (!needAuth) {
      hasAuthorized.value = true
      return
    }
    const authInfo = UserAuthorizationStorage.get<BooleanObject>()
    if (!defaultKey) {
      // 未传入defaultkey，优先不影响使用为主
      hasAuthorized.value = true
    } else {
      hasAuthorized.value = !!authInfo?.[defaultKey]
    }
  }
  // 使用时默认初始化
  initUserAuthInfo()

  return {
    checkAuthorizationHandle,
    hasAuthorized,
    beforeAuthOpenWxMiniProgramHandle,
  }
}
export function useUserNearbyWarehouseVerify() {
  return useUserPermissionVerify(USER_NEARBY_WAREHOUSE_AUTH)
}
